The identifier for the `PositionProfile` that was closed.
